import { Button, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import WhatsappContact from '../components/WhatsappContact';
import GmailContact from '../components/GmailContact';
import { colors } from '../Theme/tokens';
import { PrimaryButton } from '../Theme';

export default function FeatureSoon({open, transactionType,handleContactUsClose }) {

  return (
    <>
     <Dialog
            open={open}
            onClose={handleContactUsClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{sx: { borderRadius: '10px' }}}
          >
            <Box sx={{display:"flex", flexDirection:"column", maxWidth:"400px"}}>
            <DialogTitle id="alert-dialog-title" sx={{textAlign:"center", fontWeight:"500", fontSize:"18px", px:0, color:colors.text.primary}}>
              Feature Coming Soon
            </DialogTitle>
            <DialogContent sx={{px:3, pb:1}}>
              <DialogContentText id="alert-dialog-description" sx={{color: colors.text.secondary, textAlign:"center",color:colors.text.gray}}>
              This functionality is currently a work in progress as we integrate with our partners. If you need assistance with {transactionType}, please contact us
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{justifyContent:"center", py:0}}>
            <GmailContact />
              OR
              <WhatsappContact />
            </DialogActions>
            <DialogActions sx={{justifyContent:"center",mb:1}}>
              <PrimaryButton onClick={handleContactUsClose} variant='contained' sx={{width:"90%", fontWeight:"400"}}>OK</PrimaryButton>
            </DialogActions>
            </Box>
          </Dialog>
    </>
  )
}
